var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('Title',{attrs:{"title":"长者增长趋势","className":"ny-title-small"}}),_c('div',{staticClass:"layout-view flex-grow"},[_c('PlatformElderIncreaseTendencyChart')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }